import axios from "axios";


export default class Authservices {

  static login(email: any, password: any) {
      return axios.post(process.env.REACT_APP_LOGIN_API as string, {
        "email": email,
        "password": password
      })

  }

  static logout(token: any) {
    return axios.post(process.env.REACT_APP_LOGOUT_API as string,{
      headers: {
        'Authorization': 'Bearer ' +  token
      }
    })
  }

}
